$(function(){
    SliderFade();
});

$( window ).load(function() {
    SliderHeightSetup();
    $(".SliderFade").addClass('loaded');
});

function SliderFade() {

    SFplay = [];

    /* LI SETUP */

    $(".SliderFade").each(function () {
        var $sliderTarget = $(this);
        var items = $sliderTarget.children("ul").children('.prod');
        if ($(this).hasClass('large')){
            for(var i = 0; i < items.length; i+=2) {
                items.slice(i, i+2).wrapAll("<li></li>");
            }
        }
        if ($(this).hasClass('small')){
            for(var i = 0; i < items.length; i+=1) {
                items.slice(i, i+1).wrapAll("<li></li>");
            }
        }
        $(this).children('ul').children('li').first().addClass('first active').css({'display':'block'});
        $(this).children('ul').children('li').last().addClass('last');
    });
    $(".SliderFade li").each(function(){
        var LiIndex = $(this).index();
        $(this).attr({rel:LiIndex}).addClass('li'+LiIndex+'');
    });

    /* PREV NEXT SETUP */

    $(".SliderFade").append('<div class="prevnextnav"><a class="prev"></a><a class="next"></a></div>');

    /* BULLET SETUP */

    $(".SliderFade").each(function(){
        var $sliderTarget = $(this);
        var items = $sliderTarget.find(".bulletnav").children('img');
        if ($(this).hasClass('large')){
            for(var i = 0; i < items.length; i+=2) {
                items.slice(i, i+2).wrapAll("<a></a>");
            }
        }
        if ($(this).hasClass('small')){
            for(var i = 0; i < items.length; i+=1) {
                items.slice(i, i+1).wrapAll("<a></a>");
            }
        }
        $sliderTarget.find(".bulletnav a").each(function(){$(this).attr({rel:$(this).index()});});
        $sliderTarget.find(".bulletnav a").first().addClass('active');
    });
    
    /* KEY EVENT */
    
    $(document).keyup(function(e){
        console.log($(window).width());
        if ( $(window).width() > 1024 ) { $sliderTarget = $('.SliderFade.large') } 
        else { $sliderTarget = $('.SliderFade.small') };
        if (e.keyCode==39) { nextSlide($sliderTarget) }
        else if (e.keyCode==37) { prevSlide($sliderTarget) };
    });

    /* SWIPE LEFT */
    
    $(".SliderRotateHorizontal").on("swipeleft", function(event){
        var $sliderTarget = $( event.target ).parents('.SliderFade');
        nextSlide($sliderTarget);
    });
    
    /* SWIPE RIGHT */
    
    $(".SliderRotateHorizontal").on("swiperight", function(event){
        var $sliderTarget = $( event.target ).parents('.SliderFade');
        prevSlide($sliderTarget);
    });
    
    /* NEXT CLICK */
    
    $(".SliderFade").find(".prevnextnav a.next").click(function(){
        var $sliderTarget = $(this).parents('.SliderFade');
        nextSlide($sliderTarget);
    });
    
    /* PREV CLICK */ 
       
    $(".SliderFade").find(".prevnextnav a.prev").click(function(){
        var $sliderTarget = $(this).parents('.SliderFade');
        prevSlide($sliderTarget);	
    });
    
    /* NEXT SLIDE */
    
    function nextSlide($sliderTarget){
        var activeLiIndex = $sliderTarget.find("li.active").index();
        var LastLiIndex = $sliderTarget.find("li.last").index();
        var i = $sliderTarget.attr('rel');
        if(SFplay[i]){clearTimeout(SFplay[i])};		
        if (LastLiIndex > activeLiIndex)  {
            $sliderTarget.find("li.active").removeClass("active").next().addClass("active");
            rotate($sliderTarget);
        } else {
            $sliderTarget.find("li.active").removeClass("active")
            $sliderTarget.find("li").first().addClass("active");
            rotate($sliderTarget);
        };
    };
    
    /* PREV SLIDE */
    
    function prevSlide($sliderTarget){
        var activeLiIndex = $sliderTarget.find("li.active").index();
        var FirstLiIndex = $sliderTarget.find("li.first").index();
        var i = $sliderTarget.attr('rel');
        if(SFplay[i]){clearTimeout(SFplay[i])};
        if (FirstLiIndex < activeLiIndex)  {
            $sliderTarget.find("li.active").removeClass("active").prev().addClass("active");
            rotate($sliderTarget);
        } else {
            $sliderTarget.find("li.active").removeClass("active")
            $sliderTarget.find("li").last().addClass("active");
            rotate($sliderTarget);
        };		
    };

    /* BULLET CLICK */

    $(".SliderFade").find(".bulletnav a").click(function(){
        var $sliderTarget = $(this).parents('.SliderFade');
        var LiTarget = $(this).attr('rel');
        $sliderTarget.find("li").removeClass("active");
        $sliderTarget.find("li[rel="+LiTarget+"]").addClass("active");
        var i = $sliderTarget.attr('rel');
        if(SFplay[i]){clearTimeout(SFplay[i])};
        rotate($sliderTarget);
    });

    /* ROTATE */

    function rotate($sliderTarget) {
        var activeLiIndex = $sliderTarget.find("li.active").index();		
        $sliderTarget.find(".bulletnav a[rel="+activeLiIndex+"]").addClass('active').siblings().removeClass('active');
        $sliderTarget
        .find("li.active")
        .fadeIn('fast')
        .promise()
        .done(function(){
            $(this).siblings().css({'display':'none'})
        });

        var activeLiSmallIndex;
        var activeLiLargeIndex;

        if($sliderTarget.hasClass('large')){
            if (activeLiIndex == 0){ activeLiSmallIndex = 0 }
            if (activeLiIndex == 1){ activeLiSmallIndex = 2 }
            if (activeLiIndex == 2){ activeLiSmallIndex = 4 }
            $('.SliderFade.small').find(".bulletnav a[rel="+activeLiSmallIndex+"]").addClass('active').siblings().removeClass('active');
            $('.SliderFade.small').find("li[rel="+activeLiSmallIndex+"]").addClass('active').siblings().removeClass('active');
            $('.SliderFade.small').find("li.active").fadeIn('fast').promise().done(function(){$(this).siblings().css({'display':'none'})});
        } else {
            if (activeLiIndex < 6){ activeLiLargeIndex = 2 }
            if (activeLiIndex < 4){ activeLiLargeIndex = 1 }
            if (activeLiIndex < 2){ activeLiLargeIndex = 0 }
            $('.SliderFade.large').find(".bulletnav a[rel="+activeLiLargeIndex+"]").addClass('active').siblings().removeClass('active');
            $('.SliderFade.large').find("li[rel="+activeLiLargeIndex+"]").addClass('active').siblings().removeClass('active');
            $('.SliderFade.large').find("li.active").fadeIn('fast').promise().done(function(){$(this).siblings().css({'display':'none'})});
        }
        zoom();
    };

};

function SliderHeightSetup(){

    var SliderLargeHeight = $(".SliderFade.large").find('li.active').find('img').height();
    $(".SliderFade.large").height(SliderLargeHeight);

    var SliderSmallHeight = $(".SliderFade.small").find('li.active').find('img').height();
    $(".SliderFade.small").height(SliderSmallHeight);

};

$(window).resize(function(){
    SliderHeightSetup();
});